'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnorderedLists;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UnorderedList = require('./UnorderedList');

var _UnorderedList2 = _interopRequireDefault(_UnorderedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type" : "unordered_list",
    "content": [
      "item 1",
      "item 2",
      "item 3"
    ],
    "class": "some-class-name"
  }

  For rendering a `<ul>` element with some content.

  Accepts the attributes `content`, denoting the
  `<li>` elements in the list, and a `class`
  attribute, for setting a custom class name. Ideally,
  styling of the list would cascade from the top level
  CSS class name, but for things like setting a
  half-width list I felt this would be helpful to add.
*/

function UnorderedLists(_ref) {
  var content = _ref.content;

  return _react2.default.createElement(
    'div',
    { className: 'listings type-unordered_lists' },
    content.map(function (_ref2, key) {
      var title = _ref2.title,
          copy = _ref2.copy,
          heading1 = _ref2.heading1,
          heading2 = _ref2.heading2,
          location = _ref2.location;
      return _react2.default.createElement(_UnorderedList2.default, {
        key: key,
        title: title,
        copy: copy,
        heading1: heading1,
        heading2: heading2,
        location: location
      });
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UnorderedList/UnorderedLists.jsx
// module id = 1272
// module chunks = 0